var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import _ from "lodash";
var LiteralType = /* @__PURE__ */ ((LiteralType2) => {
  LiteralType2["STRING"] = "string";
  LiteralType2["NUMBER"] = "number";
  LiteralType2["BOOLEAN"] = "boolean";
  LiteralType2["VERSION"] = "version";
  return LiteralType2;
})(LiteralType || {});
class FilterExpressionVariantListener {
  constructor() {
    /// <summary>
    /// Gets variant types.
    /// </summary>
    __publicField(this, "variantTypes", {});
  }
  enterFilterBetween(context) {
    const variant = context.VARIANT();
    const literals = context.literal();
    this.register(variant, literals);
  }
  enterFilterBinary(context) {
    const variant = context.VARIANT();
    const literal = context.literal();
    this.register(variant, [literal]);
  }
  enterFilterIn(context) {
    const variant = context.VARIANT();
    const literals = context.literalList().literal();
    this.register(variant, literals);
  }
  register(variantToken, literals) {
    var _a;
    const variantName = (_a = variantToken.symbol.text) == null ? void 0 : _a.toLowerCase();
    let types = variantName ? this.variantTypes[variantName] : void 0;
    if (!types) {
      types = /* @__PURE__ */ new Set();
      if (variantName) {
        this.variantTypes[variantName] = types;
      }
    }
    _.each(literals, (literal) => {
      const type = FilterExpressionVariantListener.getLiteralType(literal);
      if (!!type) {
        types.add(type);
      }
    });
  }
  static getLiteralType(literal) {
    if (literal.STRING() != null) {
      return "string";
    } else if (literal.VERSION() != null) {
      return "version";
    } else if (literal.INTEGER() != null) {
      return "number";
    } else if (literal.BOOL_TRUE() != null || literal.BOOL_FALSE() != null) {
      return "boolean";
    }
    return null;
  }
}
export {
  FilterExpressionVariantListener,
  LiteralType
};
//# sourceMappingURL=FilterExpressionVariantListener.js.map
